import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/articles';

export default function ArticleListPage() {
  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: '文章资讯' },
  ];

  const pageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '抖阴pro - 文章资讯',
    description: '抖阴pro最新使用指南、功能介绍、安装教程和常见问题解答',
    url: 'https://douyinpro.com/articles',
    isPartOf: {
      '@type': 'WebSite',
      name: '抖阴pro',
      url: 'https://douyinpro.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(pageJsonLd)}</script>
      <div className="pt-20">
        <Breadcrumb items={breadcrumbItems} />

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-5xl mx-auto">
            <div className="mb-10">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                文章资讯
              </h1>
              <p className="text-foreground-600 leading-relaxed">
                抖阴pro最新使用指南、功能介绍、安装教程和常见问题解答，助您全面了解抖阴pro
              </p>
            </div>

            <div className="flex flex-col gap-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex flex-col sm:flex-row gap-5 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/70 transition-all duration-300 hover:translate-y-[-2px] cursor-pointer"
                >
                  <div className="w-full sm:w-60 h-40 rounded-xl overflow-hidden flex-shrink-0">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex flex-col justify-between flex-1 min-w-0">
                    <div>
                      <div className="flex items-center gap-3 mb-2">
                        <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                          {article.category}
                        </span>
                        <span className="text-xs text-foreground-400">{article.date}</span>
                        <span className="text-xs text-foreground-400 flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {article.readTime}
                        </span>
                      </div>
                      <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                    </div>
                    <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        {article.author}
                      </span>
                      <div className="flex flex-wrap gap-1.5">
                        {article.tags.slice(0, 2).map((tag) => (
                          <span key={tag} className="px-2 py-0.5 rounded bg-background-100 text-foreground-500">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}